import React, { useEffect } from "react";
import styled from "styled-components";
import { FlexBox } from "../../styles/Common";
import arrow from "../../styles/images/ico_arrow_down.svg";
import { getToken } from "../hooks/authFunc";
import { useDispatch } from "react-redux";
import { serviceActions } from "../../store/slices/serviceSlice";
import { returnInquireCategory } from "../hooks/basicFunc";

const FaqList = (props) => {
  const { data } = props;

  return (
    <InquiryListWrap>
      <ul>
        {data.list.map((li, index) => (
          <li key={index} className="pointer">
            <details>
              <summary>
                <StatusDiv>
                  <p>[{returnInquireCategory(Number(li.category))}]</p>
                </StatusDiv>
                <TitleDiv>
                  <div>
                    <h4>{li.question}</h4>
                  </div>
                  <img src={arrow} alt="arrow" />
                </TitleDiv>
              </summary>
              <OepenDiv>
                <p>{li.answer}</p>
              </OepenDiv>
            </details>
          </li>
        ))}
      </ul>
    </InquiryListWrap>
  );
};

export default FaqList;
const InquiryListWrap = styled.div`
  li {
    border-radius: 1rem;
    padding: 2rem 1.5rem;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
    background-color: ${({ theme }) => theme.color.white};
    margin-top: 1rem;
    &:nth-of-type(1) {
      margin-top: 0;
    }
  }

  details[open] {
    summary {
      padding-bottom: 2rem;
      img {
        transform: rotate(180deg);
      }
    }
  }
  padding-bottom: 1.5rem;
`;
const StatusDiv = styled(FlexBox)`
  justify-content: space-between;
  align-items: flex-start;
  p {
    color: ${({ theme }) => theme.color.purple_secondary};
    font-size: 12px;
    font-weight: 700;
    line-height: 16px; /* 133.333% */
  }
`;
const TitleDiv = styled(FlexBox)`
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 1rem;
  h4 {
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.2rem; /* 100% */
  }
  p {
    font-size: 1rem;
    line-height: 1rem; /* 100% */
    margin-top: 1rem;
  }
`;

const OepenDiv = styled.div`
  border-top: 1px dashed #000;
  padding-top: 2rem;
  p {
    font-size: 1.2rem;
    line-height: 1.4rem; /* 100% */
  }
`;
